export default __webpack_public_path__ + "static/media/chat.8373d23b.png";